import React from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import BlockPopup from "./BlockPopup";
import { translate } from "react-admin";

let BlockClubPopup = props => {
  const { handleBlock, handleClose, open, errorMessage } = props;
  const checkAndSubmit = () => {
    handleBlock();
  };

  return <BlockPopup {...props} resource="clubs" />;
};

BlockClubPopup.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleBlock: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  isBlocked: PropTypes.bool.isRequired
};

export default translate(connect()(BlockClubPopup));
